// React Imports
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Internationalization Import
import i18n from "i18next";
import { Button } from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  AppsListDetailRegular,
  ArrowDownloadFilled,
  MailEditRegular,
} from "@fluentui/react-icons";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";

// Internal Imports

// Props
interface IAcademyCommandBarProps {}

// Function
function AcademyCommandBar(props: IAcademyCommandBarProps) {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 800;

  const navigate = useNavigate();

  return (
    <div className="lueb-InnerContentBlockPadding2px">
      <StackShim horizontal tokens={{ childrenGap: isMobile ? 15 : 0 }}>
        <Button
          as="a"
          size={isMobile ? "large" : undefined}
          icon={<MailEditRegular />}
          appearance="subtle"
          href="mailto:service@luebbering.de?subject=eAcademy General Training"
        >
          {isMobile ? undefined : i18n.t<string>("requestTraining")}
        </Button>

        <Button
          as="a"
          size={isMobile ? "large" : undefined}
          onClick={() => {
            navigate("/academy/catalog");
          }}
          icon={<AppsListDetailRegular />}
          appearance="subtle"
        >
          {i18n.t<string>("academyCatalog")}
        </Button>

        <Button
          as="a"
          size={isMobile ? "large" : undefined}
          onClick={() => {
            fetchWrapper
              .downloadFile(
                baseUrl +
                  "/api/documents/GetDocumentFromPath?path=/DOKUMENTE/DIVERSE/" +
                  i18n.language.includes("de")
                  ? "LSMR_BROSCHUERE_DE.PDF"
                  : "LSMR_Brochure_EN.pdf",
              )
              .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  i18n.language.includes("de")
                    ? "LSMR_BROSCHUERE_DE.PDF"
                    : "LSMR_Brochure_EN.pdf",
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode?.removeChild(link);

                return true;
              });
          }}
          icon={<ArrowDownloadFilled />}
          appearance="subtle"
        >
          {i18n.t<string>("downloadLsmrBroschure")}
        </Button>
      </StackShim>
    </div>
  );
}

// Export Function
export default AcademyCommandBar;
